import { useTranslation } from "react-i18next";
import { Box, Button, Text } from "@hawkins/components";
import { Dimensions } from "@hawkins/variables";

import { Page } from "../Page";
import { StatusBanner } from "../StatusBanner";
import { TranslationNamespace } from "../../types";

export default function RequestSubmitted() {
  const { t } = useTranslation(TranslationNamespace.LEP);

  return (
    <Page>
      <Box
        display="grid"
        gridTemplateColumns={"1fr"}
        placeItems="flex-start"
        rowGap={Dimensions.Space16}
      >
        <StatusBanner
          text={t('confirm_title')}
          variant="success"
        />

        <Text bold gutterTop={Dimensions.Space6}>
          {t('confirm_body')}
        </Text>

        <Button
          href="/"
          style={{ color: 'white' }}
        >
          {t('return_home')}
        </Button>
      </Box>
    </Page>
  );
};
